import { bemComponent } from '../../utils/app';

export const ButtonGroup = bemComponent('button-group', 'ButtonGroup');
export const ButtonGroupItem = bemComponent('button-group__item', 'ButtonGroupItem');
export default ButtonGroup;
